var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"request-detail-card"},[(_vm.data || _vm.request)?_c('RequestDetailsContent',_vm._b({scopedSlots:_vm._u([{key:"actions",fn:function(){return [_vm._t("actions")]},proxy:true}],null,true)},'RequestDetailsContent',{ data: _vm.request },false)):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }